<form [formGroup]="form">
  <div class="inline-mode" [class.disabled]="!editable">
    <ng-container *ngTemplateOutlet="geoSearch"></ng-container>
    <ng-container *ngIf="showAddressFormEditor === false">
      <amp-address-viewer
        class="address-viewer"
        [attr.data-e2e]="'address-viewer'"
        [address]="currLocation.address"
        [showEditIcon]="editable"
        (displayModeChanged)="toggleAddressEditor()">
      </amp-address-viewer>
    </ng-container>
    <ng-container *ngIf="showAddressFormEditor">
      <div *ngIf="showAttentionRequiredMessage" class="attention-required-message">
        {{ 'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_PROPERTIES_EDITOR.INFO.ADDRESS.ATTENTION_REQUIRED_MESSAGE_300' | transloco }}
      </div>
      <amp-address-editor
        [attr.data-e2e]="'address-editor'"
        [siteId]="siteId"
        [address]="currLocation.address"
        [isGeoAddressValid]="isGeoAddressValid"
        [validateFormOnInitialLoad]="validateFormOnInitialLoad"
        [parentForm]="parentForm"
        (addressChanged)="onLocationChanged($event)"
      >
      </amp-address-editor>
    </ng-container>
  </div>

  <ng-template #geoSearch>
    <div class="search">
      <avn-form-field>
        <avn-geo-search
          formControlName="geoSearchInput"
          [attr.data-e2e]="'geo-search-input'"
          [label]="'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_PROPERTIES_EDITOR.INFO.ADDRESS.TITLE_35' | transloco"
          [placeholder]="'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_PROPERTIES_EDITOR.INFO.ADDRESS.PLACEHOLDER_100' | transloco"
          [searchType]="GooglePlacesSearchTypes.ADDRESS"
          (itemSelectedChange)="onGeoSearchChanged($event)"
        >
        </avn-geo-search>
      </avn-form-field>
      <span [attr.data-e2e]="'geo-warning'" [class.visible]="duplicateGeoAddressSelected$ | async" class="warning">
        {{ 'siteManagementScope.SITE_MANAGEMENT.SITE_DETAIL.SITE_PROPERTIES_EDITOR.INFO.ADDRESS.VALIDATION.DUPLICATE_ADDRESS_100' | transloco }}
      </span>
    </div>
  </ng-template>
</form>
